export default class JobCard {
  constructor(selector = ".job-card") {
    this.$card = $(selector);
    this.$card.find(".js-clipboard-copy").on("click", this.copyToClipboardHandler.bind(this));
  }

  copyToClipboardHandler(event) {
    const $button = $(event.currentTarget);
    const text = $button.parent().find(".field-value").text().trim();
    navigator.clipboard.writeText(text);
    this.showCopyToClipboardFeedback($button);
  }

  showCopyToClipboardFeedback($element) {
    $element.attr("data-original-title", "Copied");
    $element.data("bs.tooltip").show();
    $element.attr("data-original-title", "Copy to Clipboard");
  }
}
